import { FunctionComponent, memo } from "react";

import AnomalyDetail from "../anomaly-detail";

import { IProps } from "./anomaly-model.types";
import "./anomaly-model.scss";

/**
 * Show anomaly's model name
 * @param props.tags Anomaly's model name.
 * @returns          Anomaly's model name and icon.
 */
const AnomalyModel: FunctionComponent<IProps> = ({ model, ...anomalyDetailProps }) => {
    return <AnomalyDetail {...anomalyDetailProps} label="Model" styleName="primary" value={model} />;
};

export default memo(AnomalyModel);
